webpackJsonp([114276838955818,60335399758886],{

/***/ 70:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(120);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(70);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Favicons = function Favicons(props) {
	    return _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        console.log(props),
	        _react2.default.createElement('link', { rel: 'apple-touch-icon', sizes: '180x180', href: props.dir + '/apple-touch-icon.png' }),
	        _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '32x32', href: props.dir + '/favicon-32x32.png' }),
	        _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '16x16', href: props.dir + '/favicon-16x16.png' }),
	        _react2.default.createElement('link', { rel: 'mask-icon', href: props.dir + '/safari-pinned-tab.svg', color: '#5bbad5' }),
	        _react2.default.createElement('link', { rel: 'shortcut icon', href: props.dir + '/favicon.ico' }),
	        _react2.default.createElement('meta', { name: 'msapplication-config', content: props.dir + '/browserconfig.xml' })
	    );
	};
	
	exports.default = Favicons;
	
	
	Favicons.propTypes = {
	    dir: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _siteConfig = __webpack_require__(10);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Typekit = __webpack_require__(116);
	
	var _Typekit2 = _interopRequireDefault(_Typekit);
	
	var _Favicons = __webpack_require__(114);
	
	var _Favicons2 = _interopRequireDefault(_Favicons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Head = function Head() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactHelmet2.default, {
	            htmlAttributes: { lang: 'en' }
	        }),
	        _siteConfig2.default.typekitID && _react2.default.createElement(_Typekit2.default, { id: _siteConfig2.default.typekitID }),
	        _siteConfig2.default.faviconDir && _react2.default.createElement(_Favicons2.default, { dir: _siteConfig2.default.faviconDir })
	    );
	};
	
	exports.default = Head;
	module.exports = exports['default'];

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TypekitScript = function TypekitScript(props) {
	    return _react2.default.createElement(
	        'script',
	        null,
	        '\n        (function(d) {\n            var config = {\n                kitId: \'' + props.id + '\',\n                scriptTimeout: 3000,\n                async: true\n            },\n            h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src=\'https://use.typekit.net/\'+config.kitId+\'.js\';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)\n        })(document);         \n    '
	    );
	};
	
	var Typekit = function Typekit(props) {
	    return _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        TypekitScript(props)
	    );
	};
	
	exports.default = Typekit;
	
	
	TypekitScript.propTypes = {
	    id: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(44);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(204);
	
	var _siteConfig = __webpack_require__(10);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Head = __webpack_require__(115);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { style: { padding: 20 } },
	        _react2.default.createElement(_Head2.default, null),
	        _react2.default.createElement(
	            'h1',
	            null,
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/' },
	                _siteConfig2.default.meta.siteTitle
	            )
	        ),
	        _react2.default.createElement(
	            'nav',
	            null,
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/posts' },
	                        'Posts'
	                    )
	                )
	            )
	        ),
	        children()
	    );
	};
	
	exports.default = TemplateWrapper;
	
	
	TemplateWrapper.propTypes = {
	    children: _propTypes2.default.func.isRequired
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-75d17c1023626f24a298.js